import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SectionsContextType {
  showSectionsAboveCalendar: boolean;
  setShowSectionsAboveCalendar: (show: boolean) => void;
}

const SectionsContext = createContext<SectionsContextType | undefined>(undefined);

export const useSections = () => {
  const context = useContext(SectionsContext);
  if (context === undefined) {
    throw new Error('useSections must be used within a SectionsProvider');
  }
  return context;
};

interface SectionsProviderProps {
  children: ReactNode;
}

export const SectionsProvider: React.FC<SectionsProviderProps> = ({ children }) => {
  const [showSectionsAboveCalendar, setShowSectionsAboveCalendar] = useState(true);

  return (
    <SectionsContext.Provider value={{ showSectionsAboveCalendar, setShowSectionsAboveCalendar }}>
      {children}
    </SectionsContext.Provider>
  );
}; 